import { ColorQuiz } from '../components/quiz';

export default ColorQuiz;
